import { Loading, SearchTable as SearchTableShell } from 'corso-admin-ui';
import { CrewMerchantApi } from 'corso-types';
import { useNavigate } from 'react-router-dom';
import {
  convertStateToSearch,
  useSearchState,
} from './searchControlBar/SearchContext';
import SearchControlBar from './searchControlBar/SearchControlBar';
import { useColumnDefinition } from './useColumnDefinition';
import useSearchData from './useSearchData';

type Search = Omit<
  CrewMerchantApi.RequestBody<'/:storeId/search', 'post'>,
  'take' | 'cursor'
>;

const entityLabel = {
  Return: 'claims',
  Warranty: 'claims',
  Registration: 'registrations',
  Shipping: 'claims',
  Order: 'orders',
  Product: 'products',
} satisfies Record<Search['kind'], string>;

export default function SearchTable() {
  const [searchState, dispatch] = useSearchState();
  const navigate = useNavigate();
  const columns = useColumnDefinition(searchState.kind);

  const { data, pageInfo, isFetching, isError, isSearchTooLong, refetch } =
    useSearchData(convertStateToSearch(searchState));

  return (
    <SearchTableShell<(typeof data)[number]> // ? why does this satisfy TypeScript, when the inferred type does not
      controls={
        <>
          <SearchControlBar isSearchPending={isFetching} />
          {isFetching && <Loading />}
        </>
      }
      data={data}
      columns={columns}
      pageInfo={pageInfo}
      onPageChange={(cursor) => dispatch({ type: 'setCursor', cursor })}
      // ! only valid non-order tables, unless we add a relevant page for it
      onRowClick={(record) => navigate(`${record.id}`)}
      isFetching={isFetching}
      isError={isError}
      onRetry={() => {
        // oxlint-disable-next-line @typescript-eslint/no-floating-promises
        refetch();
      }}
      isSearchTooLong={isSearchTooLong}
      entityLabel={entityLabel[searchState.kind]}
      onClearFilters={() => dispatch({ type: 'removeFilters' })}
    />
  );
}
